var chunkToChildrenMap = {
	"49582": [
		99215
	],
	"52966": [
		99215
	],
	"58072": [
		93675,
		33332,
		75642
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));